import _ from 'lodash';
import { Component, Fragment } from 'react';
import { SelectWithSearch } from '../selectWithSearch';
import messages from './AutoCompany.messages';
import { FormattedMessage, injectIntl } from 'react-intl';
import styles from './AutoCompany.module.css';

class AutoCompany extends Component {
    handleOnChange = (value) => {
        this.props.onChange(value);
        this.props.fetchCompanies(value);
    };

    getSelectedLabel = () => {
        const { companyName } = this.props;

        if (_.get(companyName, 'input')) {
            return `${companyName.input.value}`;
        }
    };

    renderNoResults() {
        return (
            <div className={styles.noResults}>
                <span className={styles.title}>
                    <FormattedMessage {...messages.companyNotFoundErrorTitle} />
                </span>

                <span className={styles.content}>
                    <FormattedMessage
                        {...messages.companyNotFoundErrorContent}
                    />
                </span>
            </div>
        );
    }

    renderNoSearchTerm() {
        return (
            <div className={styles.noSearchTerm}>
                <div className={styles.title}>
                    <FormattedMessage {...messages.searchForCompany} />
                </div>
                <div className={styles.content}>
                    <FormattedMessage {...messages.noSearchTermContent} />
                </div>
            </div>
        );
    }

    renderLocalisedLabel() {
        return <FormattedMessage {...messages.registeredCompanyName} />;
    }

    buildCompanyLabel(company) {
        return `${company.name} (${company.number})`;
    }

    onSelect = (item) => {
        const { companies, companyName, companyNumber, onChangePrompt } =
            this.props;
        let selectedCompany;

        if (item) {
            selectedCompany = _.find(companies, {
                number: item.value
            });
        }

        if (selectedCompany) {
            if (companyName && companyNumber) {
                companyName.input.onChange(selectedCompany.name);
                companyNumber.input.onChange(selectedCompany.number);
                onChangePrompt();
            }
        }
    };

    renderCompanies = () => {
        const { companies } = this.props;

        if (!companies) {
            return [];
        }

        return _.map(companies, (company) => {
            return {
                label: `${this.buildCompanyLabel(company)}`,
                value: company.number
            };
        });
    };

    render() {
        const {
            companies,
            fetchCompaniesPending,
            toggleManualCompanyState,
            companyName
        } = this.props;

        const label = this.renderLocalisedLabel();
        const value = _.get(companyName, 'input.value') || null;

        return (
            <>
                <label className={styles.label}>{label}</label>
                <SelectWithSearch
                    className={styles.AutoCompany}
                    value={value}
                    onChange={this.handleOnChange}
                    onBlur={this.handleOnChange}
                    onButtonClick={this.handleOnChange}
                    items={this.renderCompanies()}
                    isSuccess={companies}
                    isLoading={fetchCompaniesPending}
                    onSelect={this.onSelect}
                    manualSwitchText={
                        <FormattedMessage {...messages.chooseCompanyLinkText} />
                    }
                    noResultsRenderer={this.renderNoResults}
                    noSearchTermRenderer={this.renderNoSearchTerm}
                    warningRenderer={this.warningRenderer}
                    manualSwitch={toggleManualCompanyState}
                    selectedLabel={this.getSelectedLabel()}
                    helperText={
                        <FormattedMessage
                            {...messages.chooseCompanyHelperText}
                        />
                    }
                    switchPosition={'top'}
                    placeholder={'Search...'}
                />
                <div className={styles.toggleManualCompany}>
                    <FormattedMessage {...messages.manualCompanyToggle} />{' '}
                    <span
                        className={styles.manualCompanyToggleLink}
                        onClick={toggleManualCompanyState}
                    >
                        <FormattedMessage
                            {...messages.manualCompanyToggleLinkText}
                        />
                    </span>
                </div>
            </>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default injectIntl(AutoCompany);
